export const CHASE_FREEDOM_UNLIMITED_OFFER_ID = '84e1494c-bae2-4b0d-ac8d-e8c095ceb2fe';
export const CHASE_SAPPHIRE_RESERVE_OFFER_ID = 'd89e10ed-e781-4d28-ae74-205056a10244';
export const CHASE_SAPPHIRE_PREFERRED_OFFER_ID = '7dce19da-5d96-4502-9fd2-70ff9655f13a';

export const CHASE_DIRECT_OFFER_IDS = [
  CHASE_FREEDOM_UNLIMITED_OFFER_ID,
  CHASE_SAPPHIRE_PREFERRED_OFFER_ID,
];

export const CHASE_DIRECT_LINK_ELIGIBLE_SLUGS = [
  // review pages
  'chase-sapphire-reserve',
];
